import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";
import Home from "@/components/Home";
import ResetPassword from "@/components/ResetPassword";
import api from "@/api";
import store from "@/store";
Vue.use(Router);
let router = new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/code",
      name: "Home",
      component: Home
    },
    {
      path: "/resetpassword",
      name: "ResetPassword",
      component: ResetPassword
    }
  ]
});
router.beforeEach(async (to, from, next) => {
  try {
    let user = await api.isLoggedin();
    store.commit("login", user);
    next();
  } catch (e) {
    store.commit("logout");
    if (to.matched.some(record => record.meta.auth)) {
      return next({
        path: "/"
      });
    }
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js